import React, {useEffect, useState} from "react";
import axios from "axios";
import moment from "moment";
import Calendar from "../components/Calendar";
import {getExtremeYears, prepareEvents} from "../helpers/eventsFilters";
import MonthNavigator from "../components/MonthNavigator";
import YearNavigator from "../components/YearNavigator";
import Legend from "../components/Legend";
import GlobalContext from "../GlobalContext";

const InvestorCalendars = () => {

  const [events, setEvents] = useState([]);
  const [selectedDay, setSelectedDay] = useState(moment().date());
  const [selectedMonth, setSelectedMonth] = useState(moment().month());
  const [selectedYear, setSelectedYear] = useState(moment().year());

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    const query = "/api/node/event";

    axios
      .get(query)
      .catch(error => {
        console.error(error);
      })
      .then(resp => {
        if (resp && resp.status === 200) {
          setEvents(prepareEvents(resp.data));
        } else {
          console.error("No data");
        }
      })
  }

  const CONTEXT = {
    events: events,
    eventsExtremeDates: getExtremeYears(events),
    selectedDay: selectedDay,
    selectedMonth: selectedMonth,
    selectedYear: selectedYear,
    setSelectedDay: day => setSelectedDay(day),
    setSelectedMonth: month => setSelectedMonth(month),
    setSelectedYear: year => {setSelectedYear(year)},
    DATE_FORMAT: 'YYYY-MM-DD',
    DAYS_TRANSLATIONS: [
      Drupal.t("Mon."),
      Drupal.t("Tue."),
      Drupal.t("Wed."),
      Drupal.t("Thu."),
      Drupal.t("Fri."),
      Drupal.t("Sat."),
      Drupal.t("Sun."),
    ],
    MONTHS_TRANSLATIONS: [
      Drupal.t("January"),
      Drupal.t("February"),
      Drupal.t("March"),
      Drupal.t("April"),
      Drupal.t("May"),
      Drupal.t("June"),
      Drupal.t("July"),
      Drupal.t("August"),
      Drupal.t("September"),
      Drupal.t("October"),
      Drupal.t("November"),
      Drupal.t("December")
    ],
    EVENT_TYPE: {
      periodical_report: {
        class: "color-background-red",
        color: "#b50043"
      },
      closed_period: {
        class: "color-background-gray",
        color: "#adb5bd"
      },
      corporate_event: {
        class: "color-background-orange",
        color: "#fc9200"
      }
    }
  };

  return (
    <div className="investor-calendar pb-4">
      <GlobalContext.Provider value={CONTEXT}>
            <YearNavigator />
        <div className="row align-items-end p-4">
          <div className="col-12">
            <MonthNavigator/>
            <Calendar/>
          </div>
          {/*<div className="col-md-12 col-lg-3 col-xl-4">*/}
              {/*<Legend/>*/}
          {/*</div>*/}
        </div>
      </GlobalContext.Provider>
    </div>
  );
};

export default InvestorCalendars;
